export const GREETINGS_CARD_SKUS = new Set(['pgreet', 'pfgrcd']);
